class GridSlider extends HTMLElement {
  constructor() {
    super(); 
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);
      var this2 = this;
      var init = false;
      var swiper;     
      function gridswiperCard() {
        if (window.innerWidth <= 990) {
          if (!init) {
            init = true;
            swiper = new Swiper(
              ".custom-grid-slider-" + this2.getAttribute("data-slider"),
              {
                slidesPerView: 1,
                centeredSlides: true,
                spaceBetween: 20,
                pagination: {
                  el: ".swiper-pagination",
                  clickable: true,
                },
                breakpoints: {
                  768: {
                    centeredSlides: false,
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                },
              }
            );
          }
        } else if (init) {
          swiper.destroy();
          init = false;
        }
      }
      gridswiperCard();
      window.addEventListener("resize", gridswiperCard);
    };
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });
    observer.observe(this);
  }
}
customElements.define("grid-slider", GridSlider);      

class CategorySlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $(document).ready(function () {
        // Initialize an object to keep track of initialized Swipers
        var initializedSliders = {};

        // Set the first item and first slider as active by default
        var first_slider = $(".category-item").eq(0).data("title-id");
        $(".category-item").removeClass("active");
        $(".category-item").eq(0).addClass("active");

        // Show the first slider and buttons
        $(".category-slider").hide();
        $(".category-slider[data-slider-id='" + first_slider + "']").show();
        $(".slider-button").hide();
        $(".slider-button[data-button-id='" + first_slider + "']").css(
          "display",
          "flex"
        );

        // Initialize Swiper for the first slider by default
        initializedSliders[first_slider] = new Swiper(
          ".category-slider[data-slider-id='" + first_slider + "']",
          {
            slidesPerView: 1.5,
            spaceBetween: 22,
            preloadImages: false,
            lazy: true,
            centeredSlides: true,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            breakpoints: {
              640: {
                slidesPerView: 1.5,
                spaceBetween: 22,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 22,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 22,
                centeredSlides: false,
              },
              1440: {
                slidesPerView: 5,
                spaceBetween: 22,
                centeredSlides: false,
              },
            },
            on: {
              init: function () {
                this.el.style.visibility = "visible";
              },
            },
          }
        );

        // Handle click events on category items
        $(".category-item").click(function () {
          var slider = $(this).data("title-id");

          // Remove active class from all and add to the clicked one
          $(".category-item").removeClass("active");
          $(this).addClass("active");

          // Hide all sliders and buttons, show the relevant ones
          $(".slider-button").hide();
          $(".category-slider").hide();
          $(".category-slider[data-slider-id='" + slider + "']").show();
          $(".slider-button[data-button-id='" + slider + "']").css(
            "display",
            "flex"
          );

          // Initialize Swiper for the selected slider if it hasn't been initialized
          if (!initializedSliders[slider]) {
            initializedSliders[slider] = new Swiper(
              ".category-slider[data-slider-id='" + slider + "']",
              {
                slidesPerView: 1.5,
                spaceBetween: 22,
                preloadImages: false,
                lazy: true,
                centeredSlides: true,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                breakpoints: {
                  640: {
                    slidesPerView: 1.5,
                    spaceBetween: 22,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 22,
                  },
                  1024: {
                    slidesPerView: 4,
                    spaceBetween: 22,
                    centeredSlides: false,
                  },
                  1440: {
                    slidesPerView: 5,
                    spaceBetween: 22,
                    centeredSlides: false,
                  },
                },
                on: {
                  init: function () {
                    this.el.style.visibility = "visible";
                  },
                },
              }
            );
          } else {
            // Update Swiper if it was previously initialized
            initializedSliders[slider].update();
          }
        });
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("feature-slider", CategorySlider);

class DiscountAnnoucement extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      var this2 = this;
      var init = false;
      var discountswier;
      var sectionid = this.getAttribute("data-sectionid");

      function swiperCard() {
        if (window.innerWidth <= 990) {
          if (!init) {
            init = true;

            discountswier = new Swiper(
              ".discount-announcement-slider-" + sectionid,
              {
                slidesPerView: 1,
                centeredSlides: true,
                spaceBetween: 20,
                loop: true,
                autoplay: {
                  delay: 2500,
                  disableOnInteraction: true,
                },
              }
            );
          }
        } else if (init && discountswier) {
          discountswier.destroy();
          discountswier = null;
          init = false;
        }
      }

      swiperCard();
      window.addEventListener("resize", swiperCard);
    };
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });
    observer.observe(this);
  }
}
customElements.define("discount-announcement", DiscountAnnoucement);

class CustomHighlight extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      var this2 = this;
      var init = false;
      var swiper;
      var sectionid = this.getAttribute("data-sectionid");

      function swiperCard() {
        if (window.innerWidth <= 990) {
          if (!init) {
            init = true;
            swiper = new Swiper(
              ".custom-highlighted-banner-slider-" + sectionid,
              {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                autoplay: {
                  delay: 2500,
                  disableOnInteraction: true,
                },
                breakpoints: {
                  768: {
                    centeredSlides: false,
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                },
              }
            );
          }
        } else if (init && swiper) {
          swiper.destroy();
          swiper = null;
          init = false;
        }
      }
      swiperCard();
      window.addEventListener("resize", swiperCard);
    };
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });
    observer.observe(this);
  }
}
customElements.define("custom-highlighted", CustomHighlight);

class CustomIconGrid extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      var this2 = this;
      var init = false;
      var swiper;
      var sectionid = this.getAttribute("data-sectionid");

      function swiperCard() {
        if (window.innerWidth <= 990) {
          if (!init) {
            init = true;
            swiper = new Swiper(
              ".custom-icon-grid-banner-slider-" + sectionid,
              {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                autoplay: {
                  delay: 2500,
                  disableOnInteraction: true,
                },
                breakpoints: {
                  768: {
                    centeredSlides: false,
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                },
              }
            );
          }
        } else if (init && swiper) {
          swiper.destroy();
          swiper = null;
          init = false;
        }
      }
      swiperCard();
      window.addEventListener("resize", swiperCard);
    };
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });
    observer.observe(this);
  }
}
customElements.define("custom-icon-grid", CustomIconGrid);

class MediaGallery extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      var swiper = new Swiper(".mobile-thumnail-slider", {
        spaceBetween: 12.5,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
      });
      var swiper2 = new Swiper(".product-media-slider", {
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next-product",
          prevEl: ".swiper-button-prev-product",
        },
        thumbs: {
          swiper: swiper,
        },
      });
    };
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });
    observer.observe(this);
  }
}
customElements.define("media-gallery", MediaGallery);

class IngredientSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      $(".ingredient-button").click(function () {
        $(this)
          .parents("ingredients-section")
          .find(".ingredient-item")
          .css("display", "flex");
      });

      let itemsVisible = 6; // Number of items to show by default
      const totalItems = $(
        ".custom-ingredients-wrapper .ingredient-item"
      ).length;

      // Show/Hide more items on button click
      $(".ingredient-button").on("click", function () {
        if (itemsVisible === 6) {
          // Show all items
          $(this)
            .parents("ingredients-section")
            .find(".ingredient-item")
            .css("display", "flex");
          $(this).text("SHOW LESS");
          itemsVisible = totalItems;
        } else {
          // Hide items after the 6th one
          $("ingredients-section")
            .find(".ingredient-item:nth-child(n+7)")
            .hide();
          $(this).text("SHOW MORE");
          itemsVisible = 6;
        }
      });

      $(".ingredient-readmore").click(function () {
        var $currentItem = $(this).parents(".ingredient-item"); // Current ingredient-item
        var isActive = $(this).hasClass("active"); // Check if the clicked readmore is already active

        // Remove 'active' class from all readmore buttons
        $(".ingredient-readmore").removeClass("active");

        // Hide all descriptions
        $(".ingredient-description").slideUp(300);

        // If the clicked button was not active, activate it and show the description
        if (!isActive) {
          $(this).addClass("active");
          $currentItem.find(".ingredient-description").slideDown(300);
        }
      });
    };
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });
    observer.observe(this);
  }
}
customElements.define("ingredients-section", IngredientSection);

class ProductVideoSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);
      $(this).css("opacity", "1");
      var swiper = new Swiper(".product-video-slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: false,
        loop: false,
        pagination: {
          el: ".product-video-pagination",
          clickable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1440: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
        },
      });

      // $(".play-pause-button").click(function () {
      //   var button = $(this);
      //   var video = button.closest(".product-video").find("video").get(0); // Get the clicked button's video element
      //   var productVideo = button.closest(".product-video"); // Store the video container
      //   var mouseLeft = false; // Initialize a flag to track if the mouse has left the video

      //   button.hide();
      //   // Pause all other videos
      //   $("video").each(function () {
      //     if (!this.paused && this !== video) {
      //       this.pause(); // Pause any video that is playing and is not the clicked video
      //       $(this)
      //         .closest(".product-video")
      //         .find(".play-pause-button")
      //         .removeClass("active")
      //         .fadeIn(); // Remove active class and show button
      //         $(this)
      //         .closest(".product-video").find('.video-product-wrapper').show();
      //     }
      //   });

      //   // Toggle play/pause for the clicked video
      //   button.toggleClass("active");
      //   button
      //     .parents(".product-video")
      //     .find(".product-thumbnail-image")
      //     .hide();
      //   button.parents('.product-video').find('.video-product-wrapper').hide();

      //   if (video.paused) {
      //     video.play();

      //     // Fade out the button after 2 seconds
      //     setTimeout(function () {
      //       if (!video.paused && mouseLeft) {
      //         // Ensure video is still playing and mouse has left
      //         button.fadeOut();
      //       }
      //     });
      //   } else {
      //     video.pause();
      //     button.fadeIn(); // Show button when paused
      //     button.parents('.product-video').find('.video-product-wrapper').show();
      //   }

      //   // Track mouse movement over the video
      //   productVideo
      //     .on("mouseenter", function () {
      //       if (mouseLeft) {
      //         button.fadeIn(); // Show the button when hovering over the video
      //       }
      //     })
      //     .on("mouseleave", function () {
      //       mouseLeft = true; // Mark that the mouse has left the video area
      //       if (!video.paused) {
      //         setTimeout(function () {
      //           if (!video.paused) {
      //             button.fadeOut(); // Hide the button if the video is still playing
      //           }
      //         });
      //       }
      //     });
      // });
    };
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });
    observer.observe(this);
  }
}
customElements.define("product-video-slider", ProductVideoSlider);

class LogoSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var swiper = new Swiper(".logo-list-slider", {
        spaceBetween: 40,
        centeredSlides: true,
        speed: 6000,
        autoplay: {
          delay: 1,
        },
        loop: true,
        slidesPerView: "auto",
        allowTouchMove: false,
        disableOnInteraction: true,
        breakpoints: {
          768: {
            slidesPerView: "auto",
            spaceBetween: 80,
          },
        },
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-logo-slider", LogoSlider);

class BundleAndSave extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      var isincart = "false";
      var cval = 1;
      $(".bundle-lower-items .selling-plans").each(function () {
        $(this)
          .find("option")
          .each(function () {
            var str = $(this).attr("value");
            $(this).attr("value", str.replace(/[^0-9.]/g, ""));
          });
        if ($(this).parents(".bundle-product-items").data("incart") == true) {
          var planid = $(this).parents(".bundle-product-items").data("planid");
          var val = $(this)
            .parent()
            .find('option[data-planid="' + planid + '"]')
            .attr("value");
          $(this).val(val);
          $(this)
            .parents(".bundle-lower-items")
            .find(".item-count")
            .attr(
              "data-sellingplan",
              $(this)
                .find('option[value="' + val + '"]')
                .attr("data-planid")
            );
          isincart = $(this).parents(".bundle-product-items").data("incart");
          cval = val;
        } else {
          $(this).val(4);
          $(this)
            .parents(".bundle-lower-items")
            .find(".item-count")
            .attr(
              "data-sellingplan",
              $(this).find('option[value="4"]').attr("data-planid")
            );
        }
      });
      console.log(isincart + "    " + cval);
      $(".bundle-frequency")
        .find("option")
        .each(function () {
          var str = $(this).attr("value");
          $(this).attr("value", str.replace(/[^0-9.]/g, ""));
        });
      if (isincart == true) {
        $(".bundle-frequency").val(cval);
      } else {
        $(".bundle-frequency").val(4);
      }
      $(".bundle-product-details").click(function () {
        $(".bundle-product-items").find(".bundle-products-popup").hide();
        $(this)
          .parents(".bundle-product-items")
          .find(".bundle-products-popup")
          .show();
        $("body").addClass("overflow-hidden-new");
      });

      $(".bundle-products-popup-overlay").click(function () {
        $(this).parent().hide();
        $("body").removeClass("overflow-hidden-new");
      });

      $(".bundle-popup-close").click(function () {
        $(this).parents(".bundle-products-popup").hide();
        $("body").removeClass("overflow-hidden-new");
      });

      $(".bundle-nutrition-wrapper").click(function () {
        $(this)
          .parents(".bundle-product-items")
          .find(".nutrition-drawer-container")
          .addClass("active");
      });

      $(".mobile-bundle-button").click(function () {
        $(this)
          .parents(".bundle-box-wrapper")
          .find(".bundle-discount-wrapper")
          .css("display", "flex");
      });

      $(".discount-back-button").click(function () {
        $(this).parents(".bundle-discount-wrapper").hide();
      });

      $(".product-close-badge").click(function () {
        $(this).parents(".bundle-product-items").addClass("active");
        var qty =
          Number(
            $(this).parents(".bundle-product-items").find(".item-count").val()
          ) - 1;
        $(this).parents(".bundle-product-items").find(".item-count").val(qty);
        $(this)
          .parents(".bundle-product-items")
          .find(".product-count-badge")
          .html(qty);
        if (qty == 0) {
          $(this).parents(".bundle-product-items").removeClass("active");
        }
        setSelectedView();
      });

      $(".bundle-add-btn").click(function () {
        $(this).parents(".bundle-product-items").addClass("active");
        var qty =
          Number(
            $(this).parents(".bundle-product-items").find(".item-count").val()
          ) + 1;
        $(this).parents(".bundle-product-items").find(".item-count").val(qty);
        $(this)
          .parents(".bundle-product-items")
          .find(".product-count-badge")
          .html(qty);
        setSelectedView();
      });
      $("product-bundle-popup .bundle-atc").click(function () {
        $(this).parents(".bundle-product-items").addClass("active");
        var qty =
          Number(
            $(this).parents(".bundle-product-items").find(".item-count").val()
          ) + 1;
        $(this).parents(".bundle-product-items").find(".item-count").val(qty);
        $(this)
          .parents(".bundle-product-items")
          .find(".product-count-badge")
          .html(qty);
        setSelectedView();
        $(this).parents(".bundle-products-popup").hide();
        $("body").removeClass("overflow-hidden-new");
      });

      $(".bundle-frequency").change(function () {
        $(".bundle-frequency").val($(this).val());
        console.log($(this).val());
        var selval = $(this).val();
        $(".bundle-product-items").each(function () {
          $(this)
            .find(".selling-plans")
            .find('option[value="' + selval + '"]')
            .prop("selected", "selected");
          var elem = $(this)
            .find(".selling-plans")
            .find('option[value="' + selval + '"]');
          console.log(elem.data("planid"));
          $(this)
            .find(".item-count")
            .attr("data-sellingplan", elem.data("planid"));
          $(this)
            .find(".item-count")
            .attr("data-sellingprice", elem.data("planprice"));
        });
        setSelectedView();
      });

      setSelectedView();
      function setSelectedView() {
        $(".error-msg").remove();
        $(".discount-active-product").remove();
        var totalitem = 0;
        var totalprice = 0;
        var symbol = $("body").data("currency");
        $(".bundle-product-items.active").each(function () {
          totalitem = totalitem + Number($(this).find(".item-count").val());
        });
        $(".bundle-product-items.active").each(function () {
          var price =
            Number($(this).find(".item-count").data("sellingprice")) *
            Number($(this).find(".item-count").val());
          totalprice = totalprice + price;
          var pricedisc = price;
          var displayprice = "";
          if (totalitem == 2) {
            pricedisc = price * 0.9;
          } else if (totalitem == 3) {
            pricedisc = price * 0.85;
          } else if (totalitem == 4) {
            pricedisc = price * 0.8;
          } else if (totalitem >= 5) {
            pricedisc = price * 0.75;
          } else {
            displayprice = 'style="display:none"';
          }
          $(
            ".selected-product-div"
          ).prepend(` <div class="discount-active-product inner-discount-box" data-pid="${$(this).find(".item-count").data("varid")}">
                  <div class="discount-quantity">
                    <button class="quantity-button qty-minus">
                      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" class="minus-accordion">
                        <path d="M22.1667 15.1644H5.83334L5.83334 12.8311H22.1667V15.1644Z" fill="black"/>
                      </svg>
                    </button>
                    <input type="number" value="${$(this)
                      .find(".item-count")
                      .val()}" id="">
                    <button class="quantity-button qty-plus">
                      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" class="plus-accordion">
                        <path d="M22.1667 15.1644H15.1667V22.1644H12.8333V15.1644H5.83334V12.8311H12.8333V5.83105H15.1667V12.8311H22.1667V15.1644Z" fill="black"/>
                      </svg>
                    </button>
                  </div>
                  <div class="discount-active-title">
                    <div class="product--title">${$(this)
                      .find(".item-count")
                      .data("ptitle")}</div>
                    <div class="product--price">
                      <del ${displayprice}>${Shopify.formatMoney(price, symbol + "{{amount}}")}</del>
                      <span>${Shopify.formatMoney(
                        pricedisc,
                        symbol + "{{amount}}"
                      )}</span>
                    </div>
                  </div>
                  <div class="product-remove">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      focusable="false"
                      class="icon icon-close"
                      fill="none"
                      viewBox="0 0 18 17"
                    >
                      <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                    </svg> 
                  </div>
                </div>`);
        });
        $(".discount-active-product .qty-plus").click(function () {
          var elem = $(
            ".bundle-product-items[data-varid='" +
              $(this).parents(".discount-active-product").data("pid") +
              "']"
          );
          console.log(elem.find(".item-count").val() + " dfdfdfdf");
          elem.addClass("active");
          var qty = Number(elem.find(".item-count").val()) + 1;
          elem.find(".item-count").val(qty);
          elem.find(".product-count-badge").html(qty);
          setSelectedView();
        });
        $(".discount-active-product .qty-minus").click(function () {
          var elem = $(
            ".bundle-product-items[data-varid='" +
              $(this).parents(".discount-active-product").data("pid") +
              "']"
          );
          elem.addClass("active");
          var qty = Number(elem.find(".item-count").val()) - 1;
          elem.find(".item-count").val(qty);
          elem.find(".product-count-badge").html(qty);
          if (qty == 0) {
            elem.removeClass("active");
          }
          setSelectedView();
        });
        $(".discount-active-product .product-remove").click(function () {
          var elem = $(
            ".bundle-product-items[data-varid='" +
              $(this).parents(".discount-active-product").data("pid") +
              "']"
          );
          elem.removeClass("active");
          var qty = 0;
          elem.find(".item-count").val(qty);
          elem.find(".product-count-badge").html(qty);
          if (qty == 0) {
            elem.removeClass("active");
          }
          setSelectedView();
        });
        console.log(totalprice)
        if (totalitem <= 1) {
          if (totalitem == 0) {
            $('.discount-product[data-step="step-1"]').show();
          } else {
            $('.discount-product[data-step="step-1"]').hide();
          }
          $('.discount-product[data-step="step-2"]').show();
          $('.discount-product[data-step="step-3"]').show();
          $('.discount-product[data-step="step-4"]').show();
          $('.discount-product[data-step="step-5"]').show();
          $(".discount-items").removeClass("active");
          $(".saving-perc").html("0%");
          var totalsaving = 0;
          $(".total-saving").html(
            `${Shopify.formatMoney(totalsaving, symbol + "{{amount}}")}`
          );
          $(".total-bundle-price").html(
            `${Shopify.formatMoney(totalprice, symbol + "{{amount}}")}`
          );
          $(".bundle-product-items").each(function () {
            var pprice = Shopify.formatMoney(
              Number($(this).find(".item-count").data("sellingprice")),
              symbol + "{{amount}}"
            );
            var pricehtml = `${pprice}`;
            $(this).find(".product-price").html(pricehtml);
            $(this).find(".bundle-product-price").html(pricehtml);
          });
        } else if (totalitem == 2) {
          $('.discount-product[data-step="step-1"]').hide();
          $('.discount-product[data-step="step-2"]').hide();
          $('.discount-product[data-step="step-3"]').show();
          $('.discount-product[data-step="step-4"]').show();
          $('.discount-product[data-step="step-5"]').show();
          $(".discount-items").removeClass("active");
          $('.discount-items[data-step="step-1"]').addClass("active");
          $(".saving-perc").html("10%");
          var totalsaving = totalprice * 0.1;
          $(".total-saving").html(
            `${Shopify.formatMoney(totalsaving, symbol + "{{amount}}")}`
          );
          $(".total-bundle-price").html(
            `${Shopify.formatMoney(
              totalprice - totalsaving,
              symbol + "{{amount}}"
            )}`
          );
          $(".bundle-product-items").each(function () {
            var pprice = Shopify.formatMoney(
              Number($(this).find(".item-count").data("sellingprice")),
              symbol + "{{amount}}"
            );
            var discprice =
              Number($(this).find(".item-count").data("sellingprice")) * 0.9;
            var pricenow = Shopify.formatMoney(
              discprice,
              symbol + "{{amount}}"
            );
            var pricehtml = `<del>${pprice}</del> ${pricenow}`;
            $(this).find(".product-price").html(pricehtml);
            $(this).find(".bundle-product-price").html(pricehtml);
          });
        } else if (totalitem == 3) {
          $('.discount-product[data-step="step-1"]').hide();
          $('.discount-product[data-step="step-2"]').hide();
          $('.discount-product[data-step="step-3"]').hide();
          $('.discount-product[data-step="step-4"]').show();
          $('.discount-product[data-step="step-5"]').show();
          $(".discount-items").removeClass("active");
          $('.discount-items[data-step="step-2"]').addClass("active");
          $(".saving-perc").html("15%");
          var totalsaving = totalprice * 0.15;
          $(".total-saving").html(
            `${Shopify.formatMoney(totalsaving, symbol + "{{amount}}")}`
          );
          $(".total-bundle-price").html(
            `${Shopify.formatMoney(
              totalprice - totalsaving,
              symbol + "{{amount}}"
            )}`
          );
          $(".bundle-product-items").each(function () {
            var pprice = Shopify.formatMoney(
              Number($(this).find(".item-count").data("sellingprice")),
              symbol + "{{amount}}"
            );
            var discprice =
              Number($(this).find(".item-count").data("sellingprice")) * 0.85;
            var pricenow = Shopify.formatMoney(
              discprice,
              symbol + "{{amount}}"
            );
            var pricehtml = `<del>${pprice}</del> ${pricenow}`;
            $(this).find(".product-price").html(pricehtml);
            $(this).find(".bundle-product-price").html(pricehtml);
          });
        } else if (totalitem == 4) {
          $('.discount-product[data-step="step-1"]').hide();
          $('.discount-product[data-step="step-2"]').hide();
          $('.discount-product[data-step="step-3"]').hide();
          $('.discount-product[data-step="step-4"]').hide();
          $('.discount-product[data-step="step-5"]').show();
          $(".discount-items").removeClass("active");
          $('.discount-items[data-step="step-3"]').addClass("active");
          $(".saving-perc").html("20%");
          var totalsaving = totalprice * 0.2;
          $(".total-saving").html(
            `${Shopify.formatMoney(totalsaving, symbol + "{{amount}}")}`
          );
          $(".total-bundle-price").html(
            `${Shopify.formatMoney(
              totalprice - totalsaving,
              symbol + "{{amount}}"
            )}`
          );
          $(".bundle-product-items").each(function () {
            var pprice = Shopify.formatMoney(
              Number($(this).find(".item-count").data("sellingprice")),
              symbol + "{{amount}}"
            );
            var discprice =
              Number($(this).find(".item-count").data("sellingprice")) * 0.8;
            var pricenow = Shopify.formatMoney(
              discprice,
              symbol + "{{amount}}"
            );
            var pricehtml = `<del>${pprice}</del> ${pricenow}`;
            $(this).find(".product-price").html(pricehtml);
            $(this).find(".bundle-product-price").html(pricehtml);
          });
        } else if (totalitem >= 5) {
          $('.discount-product[data-step="step-1"]').hide();
          $('.discount-product[data-step="step-2"]').hide();
          $('.discount-product[data-step="step-3"]').hide();
          $('.discount-product[data-step="step-4"]').hide();
          $('.discount-product[data-step="step-5"]').hide();
          $(".discount-items").removeClass("active");
          $('.discount-items[data-step="step-4"]').addClass("active");
          $(".saving-perc").html("25%");
          var totalsaving = totalprice * 0.25;
          
          $(".total-saving").html(
            `${Shopify.formatMoney(totalsaving, symbol + "{{amount}}")}`
          );
          $(".total-bundle-price").html(
            `${Shopify.formatMoney(
              totalprice - totalsaving,
              symbol + "{{amount}}"
            )}`
          );
          $(".bundle-product-items").each(function () {
            var pprice = Shopify.formatMoney(
              Number($(this).find(".item-count").data("sellingprice")),
              symbol + "{{amount}}"
            );
            var discprice =
              Number($(this).find(".item-count").data("sellingprice")) * 0.75;
            var pricenow = Shopify.formatMoney(
              discprice,
              symbol + "{{amount}}"
            );
            var pricehtml = `<del>${pprice}</del> ${pricenow}`;
            $(this).find(".product-price").html(pricehtml);
            $(this).find(".bundle-product-price").html(pricehtml);
          });
        }
        if (totalitem > 0) {
          $(".checkout-btn").removeAttr("disabled");
          $(".mobile-bundle-button").removeClass("disabled");
          $(".mobile-bundle-button").html("BUILD MY BUNDLE NOW");
        } else {
          //$(".checkout-btn").attr("disabled", true);
          $(".mobile-bundle-button").addClass("disabled");
          $(".mobile-bundle-button").html("START ADDING PRODUCTS");
        }
      }

      $(".checkout-btn")
        .unbind()
        .click(function () {
          const url = new URL(window.location.href);
          url.searchParams.set("bundle", "true");
          window.history.replaceState(null, null, url);
          $(".error-msg").remove();
          var totalitem = 0;
          var totalprice = 0;
          $(".bundle-product-items.active").each(function () {
            totalitem = totalitem + Number($(this).find(".item-count").val());
            var price =
              Number($(this).find(".item-count").data("sellingprice")) *
              Number($(this).find(".item-count").val());
            totalprice = totalprice + price;
          });
          console.log(totalitem + " ddsdsd");
          if (totalitem <= 0) {
            $(".checkout-btn").after(
              `<div class="error-msg" style="margin-top:5px;color:red;    text-align: center;">Please select at least one item</div>`
            );
            return;
          }

          var pricedisc = totalprice;
          if (totalitem == 2) {
            pricedisc = totalprice * 0.9;
          } else if (totalitem == 3) {
            pricedisc = totalprice * 0.85;
          } else if (totalitem == 4) {
            pricedisc = totalprice * 0.8;
          } else if (totalitem >= 5) {
            pricedisc = totalprice * 0.75;
          } else {
          }

          $(this).find(".loading__spinner").removeClass("hidden");
          $(this).find(".atc-text").css("opacity", "0");
          var this2 = this;
          var bundleadded = false;

          var updates = {};

          $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json",
            success: function (cartdata) {
              var showpr = true;
              var addfree = false;
              var ID = $(".main-progress-bar-container").data("freeitem");

              for (var i = 0; i < cartdata.items.length; i++) {
                var properties = cartdata.items[i].properties;

                if (properties["_BundleItem"]) {
                  bundleadded = true;
                  updates[cartdata.items[i].key] = 0;
                }
                if (cartdata.items[i].variant_id == ID) {
                  bundleadded = true;
                  updates[cartdata.items[i].key] = 0;
                }
              }

              if (bundleadded == true) {
                fetch("/cart/update.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    updates: updates,
                  }),
                })
                  .then((response) => response.json())
                  .then((newCart) => {
                    addItems();
                  })
                  .catch(console.error);
              } else {
                addItems();
              }
            },
          });

          function addItems() {
            var items = [];

            $(".bundle-product-items.active").each(function () {
              var object = {};
              object["id"] = $(this).find(".item-count").data("varid");
              object["quantity"] = $(this).find(".item-count").val();
              var properties = { _BundleItem: true };
              object["properties"] = properties;
              object["selling_plan"] = $(this)
                .find(".item-count")
                .data("sellingplan");
              items.push(object);
            });

            let formData = {
              items: items,
            };

            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            })
              .then((response) => {
                return response.json();
              })
              .then((response) => {
                $.ajax({
                  type: "GET",
                  url: "/cart.js",
                  dataType: "json",
                  success: function (cartdata) {
                    var ID = $(".main-progress-bar-container").data("freeitem");
                    var threshhold = $(".secondstagecprice").data("price");
                    console.log(cartdata.items_subtotal_price);
                    console.log(threshhold);
                    if (cartdata.items_subtotal_price >= threshhold) {
                      $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: {
                          quantity: 1,
                          id: ID,
                          properties: { _freeGift: true },
                        },
                        dataType: "json",
                        success: function (data) {
                          $(this2).find(".loading__spinner").addClass("hidden");
                          $(this2).find(".atc-text").css("opacity", "1");
                          if (totalitem == 2) {
                            window.location.href =
                              "/checkout?discount=PF_10_3ZN3CQHYRRS0";
                          } else if (totalitem == 3) {
                            window.location.href =
                              "/checkout?discount=PF_15_WKKY7ZMCJJW5";
                          } else if (totalitem == 4) {
                            window.location.href =
                              "/checkout?discount=PF_20_HYAYET85XXVW";
                          } else if (totalitem >= 5) {
                            window.location.href =
                              "/checkout?discount=PF_25_8W26EPT10JJK";
                          } else {
                            window.location.href = "/checkout";
                          }
                        },
                      });
                    } else {
                      $(this2).find(".loading__spinner").addClass("hidden");
                      $(this2).find(".atc-text").css("opacity", "1");
                      if (totalitem == 2) {
                        window.location.href =
                          "/checkout?discount=PF_10_3ZN3CQHYRRS0";
                      } else if (totalitem == 3) {
                        window.location.href =
                          "/checkout?discount=PF_15_WKKY7ZMCJJW5";
                      } else if (totalitem == 4) {
                        window.location.href =
                          "/checkout?discount=PF_20_HYAYET85XXVW";
                      } else if (totalitem >= 5) {
                        window.location.href =
                          "/checkout?discount=PF_25_8W26EPT10JJK";
                      } else {
                        window.location.href = "/checkout";
                      }
                    }
                  },
                });
              })
              .catch((error) => {
                console.error("Error:", error);
              });
          }
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("bundle-and-save", BundleAndSave);

class BundleBannerWrapper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".bundle-button")
        .unbind()
        .click(function () {
          $(this).toggleClass("active");
          $(this)
            .parent(".content-container")
            .find(".bundle-banner-content")
            .toggle(200);
          $(this)
            .parent(".content-container")
            .find(".bundle-banner-list")
            .toggle(200);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("bundle-banner-wrapper", BundleBannerWrapper);

class ProductBundlePopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      let product = this.getAttribute("product-slide");

      console.log("product-popupslider" + product);
      var swiper = new Swiper(".bundle-popup-image-slider-" + product, {
        spaceBetween: 0,
        centeredSlides: false,
        slidesPerView: 1,
        navigation: {
          nextEl: ".product-popup-next",
          prevEl: ".product-popup-prev",
        },
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-bundle-popup", ProductBundlePopup);

window.addEventListener("pageshow", function (event) {
  resetData();
});

window.addEventListener("load", function (event) {
  resetData();
});

function resetData() {
  const url = new URL(window.location.href);
  url.searchParams.delete("bundle");
  window.history.replaceState(null, null, url);
}
